export default __webpack_public_path__ + "static/royal-canin-web-29ce9c5c083a26cf6936a28759bd2625.jpg";